// Modal.js
import React from "react";

// const Modal = ({ isOpen, onClose, children }) => {
//   if (!isOpen) return null; // Don't render the modal if it's not open

//   return (
//     <div className="fixed inset-0 bg-transparent bg-opacity-50 backdrop-blur-md flex justify-center items-center z-50">
//       <div className="bg-white rounded-lg shadow-lg w-1/3 p-6 relative">
//         <button
//           onClick={onClose}
//           className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             class="h-6 w-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M6 18L18 6M6 6l12 12"
//             />
//           </svg>
//         </button>
//         {children} {/* Render the passed content inside the modal */}
//       </div>
//     </div>
//   );
// };

// Iteration 2

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <div className="fixed inset-0 bg-[#1E1A18] bg-opacity-50 backdrop-blur-md flex justify-center items-center z-50">
      <div
        className="relative bg-white rounded-lg shadow-lg p-6 
                   w-full max-w-screen-md lg:max-w-screen-lg 
                   max-h-[85vh] lg:max-h-[70vh] overflow-y-auto"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg> */}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="cursor-pointer"
          >
            <circle cx="12" cy="12" r="12" fill="black" />

            <path
              d="M8 8 L16 16 M16 8 L8 16"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <div className="overflow-y-auto max-h-[75vh] lg:max-h-[60vh] hide-scrollbar">
          {children} {/* Render the passed content inside the modal */}
        </div>
      </div>
    </div>
  );
};

export default Modal;
